<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container">
		<button type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue()"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<mat-checkbox [checked]="isChecked"
			(click)="buttonClick(filter.getValues()[0][0])">
			{{filter.label}}
		</mat-checkbox>
	</div>
</ng-container>
